(function () {
  'use strict';

  var FALLBACK_IMAGE = 'https://cdn.shopify.com/s/files/1/0657/3424/6634/files/Dein_Design._Dein_Stein._Dein_Armband..jpg?v=1767112493';

  var PRODUCTS = [
    {
      handle: 'perlenarmband-infinity-balance-onyx-pure',
      name: 'Infinity Balance – Onyx Pure',
      category: 'Flagship',
      price: '24,99 €',
      material: 'Onyx · 8 mm',
      image: 'https://cdn.shopify.com/s/files/1/0657/3424/6634/files/Infinity.Balance_OnyxPure.png?v=1747246216',
      tags: ['naturstein', 'schwarz', 'minimalistisch', 'staerke', 'fokus', 'herren', 'unisex', 'sicher', 'flagship', 'bestseller', 'understatement', 'ruhig', 'alltag'],
      description: 'Mattschwarze Onyx-Perlen – ein Armband, das nicht schreit, sondern wirkt.',
      giftText: 'Zeitlos und stark – du kannst damit nichts falsch machen.',
      headlineByEffect: {
        strength: 'Stark. Klar. Zeitlos.',
        calm: 'Ruhe trifft Stärke.',
        style: 'Stil durch Schlichtheit.',
        understated: 'Wer weiß, der weiß.'
      },
      priority: 10,
      productUrl: '/products/perlenarmband-infinity-balance-onyx-pure'
    },
    {
      handle: 'perlenarmband-infinity-balance-golden-tiger',
      name: 'Infinity Balance – Golden Tiger',
      category: 'Statement',
      price: '24,99 €',
      material: 'Tigerauge · 8 mm',
      image: 'https://cdn.shopify.com/s/files/1/0657/3424/6634/files/Perlenarmband_Infinity._Balance_Golden_Tiger.png?v=1733850396',
      tags: ['naturstein', 'gold', 'markant', 'selbstbewusst', 'dominant', 'herren', 'staerke', 'besonderer', 'elegant', 'statement'],
      description: 'Tigerauge – Selbstbewusstsein und natürliche Kraft. Warmes Gold-Braun.',
      giftText: 'Ein Armband mit echtem Charakter – für Männer die nicht Mainstream sind.',
      headlineByEffect: {
        strength: 'Präsent. Entschlossen.',
        calm: 'Kraft mit Würde.',
        style: 'Natürliche Eleganz.',
        understated: 'Gold unter der Oberfläche.'
      },
      priority: 9,
      productUrl: '/products/perlenarmband-infinity-balance-golden-tiger'
    },
    {
      handle: 'perlenarmband-infinity-balance-lava-core',
      name: 'Infinity Balance – Lava Core',
      category: 'Geerdet',
      price: '24,99 €',
      material: 'Lavastein · 8 mm',
      image: 'https://cdn.shopify.com/s/files/1/0657/3424/6634/files/infinity_Lava_Core_Lava-Armband_mit_Onyx-Kugel_f_r_Erdung_Transformation.png?v=1763556401',
      tags: ['naturstein', 'schwarz', 'markant', 'erdung', 'stabilitaet', 'herren', 'sportlich', 'locker', 'staerke', 'struktur'],
      description: 'Lavastein mit Onyx-Mittelperle – roh, geerdet, authentisch.',
      giftText: 'Einzigartige Textur, starke Wirkung.',
      headlineByEffect: {
        strength: 'Roh. Echt.',
        calm: 'Geerdet wie ein Fels.',
        style: 'Authentizität pur.',
        understated: 'Stärke ohne Aufwand.'
      },
      priority: 8,
      productUrl: '/products/perlenarmband-infinity-balance-lava-core'
    },
    {
      handle: 'perlenarmband-infinity-balance-blue-wisdom',
      name: 'Infinity Balance – Blue Wisdom',
      category: 'Königlich',
      price: '24,99 €',
      material: 'Lapislazuli · 8 mm',
      image: 'https://cdn.shopify.com/s/files/1/0657/3424/6634/files/BlueWisdom..png?v=1747249768',
      tags: ['naturstein', 'blau', 'elegant', 'stilvoll', 'weisheit', 'unisex', 'geschenk', 'besonderer', 'partner', 'sicher', 'ruhig'],
      description: 'Tiefes Lapislazuli-Blau – Weisheit und Klarheit.',
      giftText: 'Besonders und bedeutsam – ein Geschenk das bleibt.',
      headlineByEffect: {
        strength: 'Königliche Kraft.',
        calm: 'Tiefe Ruhe.',
        style: 'Weisheit als Schmuck.',
        understated: 'Für echte Kenner.'
      },
      priority: 9,
      productUrl: '/products/perlenarmband-infinity-balance-blue-wisdom'
    },
    {
      handle: 'perlenarmband-infinity-balance-pure-malaysia',
      name: 'Infinity Balance – Pure Malaysia',
      category: 'Rein',
      price: '24,99 €',
      material: 'Malaysia Jade Weiß · 8 mm',
      image: 'https://cdn.shopify.com/s/files/1/0657/3424/6634/files/Perlenarmband_Infinity_Balance_-_Pure_Malaysia.png?v=1747245387',
      tags: ['naturstein', 'weiss', 'minimalistisch', 'elegant', 'balance', 'ruhe', 'unisex', 'partner', 'frau', 'understatement', 'sicher', 'alltag'],
      description: 'Reinweißes Malaysia Jade – Balance, Ruhe und Zuversicht.',
      giftText: 'Edel, schlicht, passt zu jedem.',
      headlineByEffect: {
        strength: 'Stille Stärke.',
        calm: 'Reine Balance.',
        style: 'Eleganz in Weiß.',
        understated: 'Dezent und edel.'
      },
      priority: 8,
      productUrl: '/products/perlenarmband-infinity-balance-pure-malaysia'
    },
    {
      handle: 'dual-core-black-mirror',
      name: 'Dual Core – Black Mirror',
      category: 'Premium',
      price: '29,99 €',
      material: 'Onyx + Obsidian · 8 mm',
      image: 'https://cdn.shopify.com/s/files/1/0657/3424/6634/files/DualCore_BlackMirror.png?v=1767608730',
      tags: ['naturstein', 'schwarz', 'premium', 'markant', 'dominant', 'herren', 'staerke', 'fokus', 'understatement', 'besonderer'],
      description: 'Matt-Onyx trifft Spiegel-Obsidian – maximale Wirkung durch klaren Kontrast.',
      giftText: 'Stark, edel, unvergesslich.',
      headlineByEffect: {
        strength: 'Zwei Kräfte, eine Form.',
        calm: 'Fokus durch Kontrast.',
        style: 'Spiegel und Matte.',
        understated: 'Schwarz. Doppelt.'
      },
      priority: 9,
      productUrl: '/products/dual-core-black-mirror'
    },
    {
      handle: 'dual-core-golden-focus',
      name: 'Dual Core – Golden Focus',
      category: 'Premium',
      price: '29,99 €',
      material: 'Tigerauge + Onyx · 8 mm',
      image: 'https://cdn.shopify.com/s/files/1/0657/3424/6634/files/DualCore_GoldenFocus.png?v=1767601930',
      tags: ['naturstein', 'gold', 'schwarz', 'premium', 'markant', 'selbstbewusst', 'herren', 'elegant', 'besonderer', 'staerke'],
      description: 'Tigerauge und Onyx – goldene Energie trifft schwarze Klarheit.',
      giftText: 'Gold und Schwarz kombiniert – das perfekte Statement-Geschenk.',
      headlineByEffect: {
        strength: 'Gold und Entschlossenheit.',
        calm: 'Energie mit Tiefe.',
        style: 'Kontrast als Eleganz.',
        understated: 'Für Kenner.'
      },
      priority: 9,
      productUrl: '/products/dual-core-golden-focus'
    },
    {
      handle: 'lederarmband-rundriemen-schwarz-6mm',
      name: 'Tridente Classico Nero',
      category: 'Klassik',
      price: '24,99 €',
      material: 'Schwarzes Leder · 6 mm',
      image: 'https://cdn.shopify.com/s/files/1/0657/3424/6634/products/LederarmbandsmallRundriemenschwarz.png?v=1660493584',
      tags: ['leder', 'schwarz', 'minimalistisch', 'maskulin', 'herren', 'alltag', 'understatement', 'sicher', 'zeitlos', 'klassisch'],
      description: 'Schwarzes Rindsleder, Dreizack-Magnetverschluss. Maskulin, reduziert.',
      giftText: 'Klassisch, immer richtig – jeder Mann trägt es gerne.',
      headlineByEffect: {
        strength: 'Maskulin. Reduziert.',
        calm: 'Klare Form.',
        style: 'Der Klassiker.',
        understated: 'Weniger. Besser.'
      },
      priority: 9,
      productUrl: '/products/lederarmband-rundriemen-schwarz-6mm'
    },
    {
      handle: 'lederarmband-dunkelbraun-8mm',
      name: 'Tridente Argento',
      category: 'Maskulin',
      price: '29,99 €',
      material: 'Dunkelbraunes Leder · 8 mm',
      image: 'https://cdn.shopify.com/s/files/1/0657/3424/6634/files/Tridente_Argento_Geflochtenes_8_mm_Lederarmband_in_Dunkelbraun_mit_silbernem_Edelstahlverschluss.jpg?v=1737023967',
      tags: ['leder', 'braun', 'silber', 'maskulin', 'markant', 'elegant', 'herren', 'alltag', 'besonderer', 'geschenk', 'zeitlos'],
      description: 'Geflochtenes Rindsleder 8 mm, silberner Dreizack-Verschluss.',
      giftText: 'Zeitlos maskulin – gefällt jedem Mann.',
      headlineByEffect: {
        strength: 'Maskulin. Kräftig.',
        calm: 'Geerdet.',
        style: 'Braun und Silber.',
        understated: 'Das Lederarmband.'
      },
      priority: 9,
      productUrl: '/products/lederarmband-dunkelbraun-8mm'
    },
    {
      handle: 'armband-segeltau-schwarz-silber',
      name: 'Nautic Force – Black Triton',
      category: 'Segeltau',
      price: '27,99 €',
      material: 'Segeltau 8 mm · Schwarz',
      image: 'https://cdn.shopify.com/s/files/1/0657/3424/6634/products/Nautic_Force-_Segeltauarmband_Black_Triton_Schwarz.jpg?v=1736339341',
      tags: ['segeltau', 'schwarz', 'markant', 'maskulin', 'herren', 'alltag', 'stark', 'dominant', 'wasserfest'],
      description: 'Schwarzes Segeltau, Dreizack-Verschluss. Stark, präsent, wasserfest.',
      giftText: 'Maskulin und hochwertig.',
      headlineByEffect: {
        strength: 'Schwarz. Stark.',
        calm: 'Fokus.',
        style: 'Dunkles Statement.',
        understated: 'Kraft ohne Worte.'
      },
      priority: 8,
      productUrl: '/products/armband-segeltau-schwarz-silber'
    },
    {
      handle: 'nautic-force-segeltauarmband-deep-blue-koenigsblau',
      name: 'Nautic Force – Deep Blue',
      category: 'Segeltau',
      price: '24,99 €',
      material: 'Segeltau 8 mm · Königsblau',
      image: 'https://cdn.shopify.com/s/files/1/0657/3424/6634/files/Nautic_Force-_Segeltauarmband_Deep_Blue_Koenigsblau_70729d67-122c-4b15-9c40-094cebe851a5.png?v=1769709548',
      tags: ['segeltau', 'blau', 'elegant', 'stilvoll', 'unisex', 'partner', 'ruhig', 'sicher', 'wasserfest', 'alltag'],
      description: 'Königsblau, 8 mm, Dreizack-Verschluss. Tief, ruhig, stilvoll.',
      giftText: 'Blau und edel – passt immer.',
      headlineByEffect: {
        strength: 'Tiefe Entschlossenheit.',
        calm: 'Blau wie das Meer.',
        style: 'Eleganz in Blau.',
        understated: 'Königsblau.'
      },
      priority: 8,
      productUrl: '/products/nautic-force-segeltauarmband-deep-blue-koenigsblau'
    },
    {
      handle: 'edelstahl-armreif-dreizack-signet',
      name: 'Valor Armreif',
      category: 'Edelstahl',
      price: '19,99 €',
      material: 'Edelstahl 316L · Dreizack',
      image: 'https://cdn.shopify.com/s/files/1/0657/3424/6634/files/Lorencik_Valor_edelstahl_armreif.jpg?v=1755004601',
      tags: ['edelstahl', 'silber', 'minimalistisch', 'elegant', 'unisex', 'understatement', 'zeitlos', 'sicher', 'partner'],
      description: 'Schmaler Edelstahl-Armreif mit Dreizack-Signet. Rostfrei, zeitlos.',
      giftText: 'Schlicht, hochwertig, immer passend.',
      headlineByEffect: {
        strength: 'Klar. Edelstahl.',
        calm: 'Stille Eleganz.',
        style: 'Minimalismus.',
        understated: 'Für Kenner.'
      },
      priority: 9,
      productUrl: '/products/edelstahl-armreif-dreizack-signet'
    },
    {
      handle: 'night-signature',
      name: 'Night Signature Bundle',
      category: 'Set',
      price: '34,99 €',
      material: 'Leder + Onyx – Premium Set',
      image: 'https://cdn.shopify.com/s/files/1/0657/3424/6634/files/NightSignature.png?v=1753768363',
      tags: ['leder', 'naturstein', 'bundle', 'schwarz', 'geschenk', 'besonderer', 'unisex', 'premium', 'sicher'],
      description: 'Schwarzes Leder und Infinity Balance Onyx – zwei Armbänder, ein Statement.',
      giftText: 'Das beste Geschenk-Set im Sortiment.',
      headlineByEffect: {
        strength: 'Doppelte Wirkung.',
        calm: 'Zwei Ruhepole.',
        style: 'Ein Set.',
        understated: 'Das vollständige Statement.'
      },
      priority: 10,
      productUrl: '/products/night-signature'
    },
    {
      handle: 'wunscharmband',
      name: 'Wunscharmband – Custom',
      category: 'Individuell',
      price: 'ab 49,99 €',
      material: 'Naturstein · Deine Wahl',
      image: FALLBACK_IMAGE,
      tags: ['naturstein', 'custom', 'individuell', 'persoenlich', 'geschenk', 'besonderer', 'partner', 'frau', 'herren'],
      description: 'Dein Armband, deine Geschichte. Jeder Stein selbst gewählt.',
      giftText: 'Das persönlichste Geschenk – weil echte Gedanken dahinterstecken.',
      headlineByEffect: {
        strength: 'Deine Stärke.',
        calm: 'Deine Ruhe.',
        style: 'Dein Stil.',
        understated: 'Einzigartig.'
      },
      priority: 7,
      productUrl: '/products/wunscharmband'
    }
  ];

  var QUESTIONS = [
    {
      id: 'r',
      q: 'Für wen ist das Armband?',
      h: null,
      o: [
        { l: 'Für mich', v: 'self' },
        { l: 'Geschenk für Partner:in', v: 'partner' },
        { l: 'Geschenk für einen Mann', v: 'man' },
        { l: 'Geschenk für eine Frau', v: 'woman' }
      ]
    },
    {
      id: 'p',
      q: 'Welcher Typ?',
      h: 'Dich selbst oder die beschenkte Person.',
      o: [
        { l: 'Ruhig & fokussiert', v: 'calm', d: 'Besonnen, geerdet, klar' },
        { l: 'Selbstbewusst & stark', v: 'confident', d: 'Präsent, markant, entschlossen' },
        { l: 'Stilvoll & elegant', v: 'elegant', d: 'Geschmackvoll, edel, bewusst' },
        { l: 'Locker & sportlich', v: 'sporty', d: 'Authentisch, aktiv, entspannt' }
      ]
    },
    {
      id: 'm',
      q: 'Material?',
      h: 'Oder lass uns wählen.',
      o: [
        { l: 'Naturstein', v: 'naturstein', d: 'Einzigartig, bedeutungsvoll' },
        { l: 'Leder', v: 'leder', d: 'Maskulin, zeitlos' },
        { l: 'Edelstahl', v: 'edelstahl', d: 'Modern, langlebig' },
        { l: 'Segeltau', v: 'segeltau', d: 'Casual, wasserfest' },
        { l: 'Überrasch mich', v: 'any', d: null }
      ]
    },
    {
      id: 's',
      q: 'Welcher Look?',
      h: null,
      o: [
        { l: 'Minimalistisch', v: 'minimal', d: 'Weniger ist mehr' },
        { l: 'Markant', v: 'bold', d: 'Fällt auf, bleibt im Gedächtnis' },
        { l: 'Elegant', v: 'elegant', d: 'Zeitlos, hochwertig' },
        { l: 'Sportlich', v: 'sporty', d: 'Lässig, alltagstauglich' }
      ]
    },
    {
      id: 'e',
      q: 'Welche Wirkung?',
      h: null,
      o: [
        { l: 'Stärke & Fokus', v: 'strength', d: 'Kraft, Klarheit, Entschlossenheit' },
        { l: 'Ruhe & Balance', v: 'calm', d: 'Geerdet, ausgeglichen' },
        { l: 'Stil & Eleganz', v: 'style', d: 'Bewusster optischer Auftritt' },
        { l: 'Understatement', v: 'understated', d: 'Subtil, für Kenner' }
      ]
    }
  ];

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function has(product, tag) {
    return product.tags.indexOf(tag) > -1;
  }

  function scoreProduct(product, answers) {
    var score = 0;
    var isGift = answers.r !== 'self';
    var materialMap = {
      naturstein: 'naturstein',
      leder: 'leder',
      segeltau: 'segeltau',
      edelstahl: 'edelstahl'
    };

    if (answers.m && answers.m !== 'any') {
      score += has(product, materialMap[answers.m]) ? 9 : -8;
    } else {
      if (has(product, 'sicher')) score += 3;
      if (has(product, 'bestseller')) score += 3;
      if (has(product, 'flagship')) score += 2;
    }

    if (answers.r === 'man' && has(product, 'herren')) score += 3;
    if (answers.r === 'self' && has(product, 'herren')) score += 2;
    if ((answers.r === 'woman' || answers.r === 'partner') && has(product, 'unisex')) score += 3;
    if ((answers.r === 'woman' || answers.r === 'partner') && (has(product, 'frau') || has(product, 'partner'))) score += 2;
    if (answers.p === 'calm' && (has(product, 'ruhig') || has(product, 'balance'))) score += 4;
    if (answers.p === 'confident' && (has(product, 'selbstbewusst') || has(product, 'dominant') || has(product, 'staerke'))) score += 4;
    if (answers.p === 'elegant' && (has(product, 'elegant') || has(product, 'stilvoll'))) score += 4;
    if (answers.p === 'sporty' && (has(product, 'sportlich') || has(product, 'locker'))) score += 4;
    if (answers.s === 'minimal' && has(product, 'minimalistisch')) score += 3;
    if (answers.s === 'bold' && (has(product, 'markant') || has(product, 'statement'))) score += 3;
    if (answers.s === 'elegant' && (has(product, 'elegant') || has(product, 'stilvoll'))) score += 3;
    if (answers.s === 'sporty' && (has(product, 'sportlich') || has(product, 'locker'))) score += 3;
    if (answers.e === 'strength' && (has(product, 'staerke') || has(product, 'fokus'))) score += 5;
    if (answers.e === 'calm' && (has(product, 'ruhig') || has(product, 'balance') || has(product, 'erdung'))) score += 5;
    if (answers.e === 'style' && (has(product, 'elegant') || has(product, 'stilvoll') || has(product, 'premium'))) score += 5;
    if (answers.e === 'understated' && has(product, 'understatement')) score += 5;

    if (isGift) {
      if (has(product, 'sicher')) score += 4;
      if (has(product, 'zeitlos')) score += 3;
      if (has(product, 'bundle')) score += 5;
    }

    score += (product.priority || 0) * .12;
    return score;
  }

  function matchPercent(score) {
    return Math.min(Math.max(Math.round(score / 40 * 100), 63), 97);
  }

  function matchLabel(percent) {
    if (percent >= 88) return 'Außergewöhnliche Übereinstimmung';
    if (percent >= 78) return 'Sehr hohe Übereinstimmung';
    if (percent >= 68) return 'Hohe Übereinstimmung';
    return 'Gute Übereinstimmung';
  }

  function getRankedProducts(answers) {
    var seen = {};
    return PRODUCTS.map(function (product) {
      var score = scoreProduct(product, answers);
      return {
        product: product,
        score: score,
        match: matchPercent(score)
      };
    }).filter(function (item) {
      if (seen[item.product.handle]) return false;
      seen[item.product.handle] = true;
      return true;
    }).sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return (b.product.priority || 0) - (a.product.priority || 0);
    });
  }

  function getTopRecommendation(answers) {
    return getRankedProducts(answers)[0];
  }

  function getAlternativeRecommendation(answers, topItem) {
    var ranked = getRankedProducts(answers);
    var top = topItem && topItem.product;
    var differentMaterial = ranked.filter(function (item) {
      return top && item.product.handle !== top.handle && item.product.material !== top.material;
    });
    var differentStyle = ranked.filter(function (item) {
      return top && item.product.handle !== top.handle && item.product.category !== top.category;
    });
    return differentMaterial[0] || differentStyle[0] || ranked.filter(function (item) {
      return !top || item.product.handle !== top.handle;
    })[0] || topItem;
  }

  function getGiftRecommendation(answers, topItem, alternativeItem) {
    var ranked = getRankedProducts(answers);
    var blocked = {};
    var giftTags = ['sicher', 'zeitlos', 'bundle', 'bestseller', 'unisex'];

    if (topItem) blocked[topItem.product.handle] = true;
    if (alternativeItem) blocked[alternativeItem.product.handle] = true;

    function giftWeight(item) {
      var weight = item.score;
      giftTags.forEach(function (tag) {
        if (has(item.product, tag)) weight += 5;
      });
      weight += (item.product.priority || 0) * .2;
      return weight;
    }

    var preferred = ranked.filter(function (item) {
      return !blocked[item.product.handle] && giftTags.some(function (tag) {
        return has(item.product, tag);
      });
    }).sort(function (a, b) {
      return giftWeight(b) - giftWeight(a);
    });

    return preferred[0] || ranked.filter(function (item) {
      return !blocked[item.product.handle];
    })[0] || ranked.filter(function (item) {
      return !topItem || item.product.handle !== topItem.product.handle;
    })[0] || topItem;
  }

  function buildRecommendations(answers) {
    var top = getTopRecommendation(answers);
    var alternative = getAlternativeRecommendation(answers, top);
    var gift = getGiftRecommendation(answers, top, alternative);
    return {
      top: top,
      alternative: alternative,
      gift: gift
    };
  }

  function init(root) {
    if (!root || root.dataset.saInitialized === 'true') return;
    root.dataset.saInitialized = 'true';

    var state = {
      step: 0,
      answers: {},
      picked: null,
      gift: false
    };

    function byId(id) {
      return root.querySelector('#' + id);
    }

    var screens = [byId('sa-s0'), byId('sa-s1'), byId('sa-s2'), byId('sa-s3')];
    var elements = {
      progress: byId('sa-pfill'),
      stepNumber: byId('sa-stepnum'),
      questionTitle: byId('sa-qttl'),
      questionHint: byId('sa-qhint'),
      options: byId('sa-opts'),
      back: byId('sa-back'),
      next: byId('sa-next'),
      self: byId('sa-btn-self'),
      gift: byId('sa-btn-gift'),
      restart: byId('sa-restart')
    };

    if (!screens[0] || !screens[1] || !screens[2] || !screens[3] || !elements.self || !elements.gift || !elements.next || !elements.back) return;

    function setText(id, text) {
      var el = byId(id);
      if (el) el.textContent = text || '';
    }

    function setHref(id, href) {
      var el = byId(id);
      if (el) el.setAttribute('href', href || '#');
    }

    function setImage(id, product) {
      var img = byId(id);
      if (!img || !product) return;
      img.onerror = function () {
        this.onerror = null;
        this.src = FALLBACK_IMAGE;
      };
      img.src = product.image || FALLBACK_IMAGE;
      img.alt = product.name || '';
    }

    function show(index) {
      screens.forEach(function (screen, i) {
        if (screen) screen.hidden = i !== index;
      });
      if (index === 1) renderQuestion();
      if (root.scrollIntoView) {
        root.scrollIntoView({
          block: 'start',
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      }
    }

    function renderQuestion() {
      var question = QUESTIONS[state.step];
      if (!question || !elements.options) return;

      elements.progress.style.width = Math.round((state.step + 1) / QUESTIONS.length * 100) + '%';
      elements.stepNumber.textContent = 'Schritt ' + (state.step + 1) + ' von ' + QUESTIONS.length;
      elements.questionTitle.textContent = question.q;

      if (question.h) {
        elements.questionHint.textContent = question.h;
        elements.questionHint.hidden = false;
      } else {
        elements.questionHint.hidden = true;
      }

      elements.next.disabled = !state.picked;
      elements.next.textContent = state.step < QUESTIONS.length - 1 ? 'Weiter →' : 'Empfehlung anzeigen →';
      elements.options.innerHTML = '';

      question.o.filter(function (option) {
        return !(state.gift && state.step === 0 && option.v === 'self');
      }).forEach(function (option) {
        var button = document.createElement('button');
        var isActive = state.picked === option.v;
        button.type = 'button';
        button.className = 'sa-opt' + (isActive ? ' active' : '');
        button.dataset.v = option.v;
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        var copy = document.createElement('div');
        var label = document.createElement('div');
        var radio = document.createElement('span');
        label.className = 'sa-opt-label';
        label.textContent = option.l;
        copy.appendChild(label);

        if (option.d) {
          var desc = document.createElement('div');
          desc.className = 'sa-opt-desc';
          desc.textContent = option.d;
          copy.appendChild(desc);
        }

        radio.className = 'sa-opt-radio';
        button.appendChild(copy);
        button.appendChild(radio);
        button.addEventListener('click', function () {
          state.picked = option.v;
          renderQuestion();
        });
        elements.options.appendChild(button);
      });
    }

    function selectedProfileText() {
      var copy = {
        calm: 'ruhigen, fokussierten',
        confident: 'selbstbewussten, starken',
        elegant: 'stilvollen, eleganten',
        sporty: 'lockeren, aktiven'
      };
      return copy[state.answers.p] || '';
    }

    function openingText() {
      var copy = {
        self: 'Das passt perfekt zu dir.',
        partner: 'Das ist ein Geschenk, das wirklich ankommt.',
        man: 'Damit liegst du bei ihm genau richtig.',
        woman: 'Das ist das Richtige für sie.'
      };
      return copy[state.answers.r] || 'Das passt perfekt.';
    }

    function alternativeReason(item, topItem) {
      var product = item && item.product;
      var top = topItem && topItem.product;
      if (!product) return 'Alternative, wenn du eine leicht andere Richtung möchtest.';
      if (has(product, 'minimalistisch') || has(product, 'understatement')) return 'Alternative, wenn du es etwas dezenter möchtest.';
      if (has(product, 'markant') || has(product, 'statement') || has(product, 'dominant')) return 'Alternative, wenn du es etwas markanter möchtest.';
      if (top && product.material !== top.material) return 'Alternative, wenn du ein anderes Material ausprobieren möchtest.';
      return 'Alternative, wenn du eine leicht andere Richtung möchtest.';
    }

    function renderSmallCard(prefix, item, reason) {
      if (!item || !item.product) return;
      var product = item.product;
      setImage('sa-' + prefix + '-img', product);
      setText('sa-' + prefix + '-name', product.name);
      setText('sa-' + prefix + '-meta', product.material + ' · ' + product.price);
      setText('sa-' + prefix + '-reason', reason);
      setHref('sa-' + prefix + '-link', product.productUrl);
    }

    function renderResult(recommendations) {
      var top = recommendations.top;
      if (!top || !top.product) return;

      var product = top.product;
      var profile = selectedProfileText();
      var headline = product.headlineByEffect[state.answers.e] || product.name;
      var reason = product.description;

      if (profile) {
        reason += ' Für eine ' + profile + ' Ausstrahlung genau richtig.';
      }

      setImage('sa-rimg', product);
      setText('sa-rpn', product.name);
      setText('sa-rpm', product.material);
      setText('sa-rpp', product.price);
      setText('sa-ro', openingText());
      setText('sa-rh', headline);
      setText('sa-rr', reason);
      setHref('sa-rcta', product.productUrl);
      setText('sa-match-pct', top.match + '%');
      setText('sa-match-label', matchLabel(top.match));

      var giftBox = byId('sa-rg');
      if (giftBox) {
        if (state.answers.r !== 'self' && product.giftText) {
          giftBox.textContent = product.giftText;
          giftBox.hidden = false;
        } else {
          giftBox.hidden = true;
        }
      }

      var matchFill = byId('sa-match-fill');
      if (matchFill) {
        matchFill.style.width = '0%';
        window.setTimeout(function () {
          matchFill.style.width = top.match + '%';
        }, prefersReducedMotion() ? 10 : 180);
      }

      renderSmallCard('alt', recommendations.alternative, alternativeReason(recommendations.alternative, top));
      renderSmallCard('gift', recommendations.gift, 'Sicherer Tipp, wenn es ein Geschenk werden soll. ' + (recommendations.gift.product.giftText || ''));
    }

    function next() {
      var question = QUESTIONS[state.step];
      if (!state.picked || !question) return;

      state.answers[question.id] = state.picked;
      state.picked = null;

      if (state.step < QUESTIONS.length - 1) {
        state.step += 1;
        state.picked = state.answers[QUESTIONS[state.step].id] || null;
        renderQuestion();
        return;
      }

      show(2);
      window.setTimeout(function () {
        var recommendations = buildRecommendations(state.answers);
        renderResult(recommendations);
        show(3);
      }, prefersReducedMotion() ? 80 : 1450);
    }

    function back() {
      if (state.step === 0) {
        reset();
        show(0);
        return;
      }

      state.step -= 1;
      state.picked = state.answers[QUESTIONS[state.step].id] || null;
      show(1);
    }

    function reset() {
      state.step = 0;
      state.answers = {};
      state.picked = null;
      state.gift = false;
      var matchFill = byId('sa-match-fill');
      if (matchFill) matchFill.style.width = '0%';
    }

    elements.self.addEventListener('click', function () {
      state.answers = { r: 'self' };
      state.step = 1;
      state.picked = null;
      state.gift = false;
      show(1);
    });

    elements.gift.addEventListener('click', function () {
      state.answers = {};
      state.step = 0;
      state.picked = null;
      state.gift = true;
      show(1);
    });

    elements.next.addEventListener('click', next);
    elements.back.addEventListener('click', back);

    if (elements.restart) {
      elements.restart.addEventListener('click', function () {
        reset();
        show(0);
      });
    }
  }

  function initAll(container) {
    var scope = container || document;
    if (scope.matches && scope.matches('#sa-wrap')) {
      init(scope);
      return;
    }
    var roots = scope.querySelectorAll ? scope.querySelectorAll('#sa-wrap') : [];
    roots.forEach(function (root) {
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
